__turbopack_context__.v({
  "arrow": "themeToggleOnboarding-module-scss-module__NViU9a__arrow",
  "body": "themeToggleOnboarding-module-scss-module__NViU9a__body",
  "closeButton": "themeToggleOnboarding-module-scss-module__NViU9a__closeButton",
  "closeIcon": "themeToggleOnboarding-module-scss-module__NViU9a__closeIcon",
  "container": "themeToggleOnboarding-module-scss-module__NViU9a__container",
  "content": "themeToggleOnboarding-module-scss-module__NViU9a__content",
  "fadeIn": "themeToggleOnboarding-module-scss-module__NViU9a__fadeIn",
  "title": "themeToggleOnboarding-module-scss-module__NViU9a__title",
});
